
// Get info about one app
export const APP_INFO_REQUEST = 'APP_INFO_REQUEST'
export const APP_INFO_SUCCESS = 'APP_INFO_SUCCESS'
export const APP_INFO_ERROR = 'APP_INFO_ERROR'

// Get content of one card
export const ONE_CARD_REQUEST = 'ONE_CARD_REQUEST'
export const ONE_CARD_SUCCESS = 'ONE_CARD_SUCCESS'
export const ONE_CARD_ERROR = 'ONE_CARD_ERROR'

// get content of all cards for one app id
export const ALL_CARDS_REQUEST = 'ALL_CARDS_REQUEST'
export const ALL_CARDS_ONE_SUCCESS = 'ALL_CARDS_ONE_SUCCESS'
export const ALL_CARDS_SUCCESS = 'ALL_CARDS_SUCCESS'
export const ALL_CARDS_ERROR = 'ALL_CARDS_ERROR'

export const ONE_CARD_FAILURE = 'ONE_CARD_FAILURE'

export const ADD_CARD = 'ADD_CARD'

export const UPDATE_CARD_REQUEST = 'UPDATE_CARD_REQUEST'
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS'
export const UPDATE_CARD_ERROR = 'UPDATE_CARD_ERROR'

export const CREATE_APP_REQUEST = 'CREATE_APP_REQUEST'
export const CREATE_APP_SUCCESS = 'CREATE_APP_SUCCESS'
export const CREATE_APP_ERROR = 'CREATE_APP_ERROR'

export const ADD_ARTICLE = 'ADD_ARTICLE'
export const REMOVE_ARTICLE = 'REMOVE_ARTICLE'



// WEBPACK FOOTER //
// ./src/constants/action-types.js